// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/var/jenkins_home/workspace/ansible-smart-bankend-deploy-szrcb/src/models/camera';
import model_4 from '/var/jenkins_home/workspace/ansible-smart-bankend-deploy-szrcb/src/.umi-production/plugin-initialState/@@initialState';
import model_2 from '/var/jenkins_home/workspace/ansible-smart-bankend-deploy-szrcb/src/models/config';
import model_3 from '/var/jenkins_home/workspace/ansible-smart-bankend-deploy-szrcb/src/models/user';

export const models = {
model_1: { namespace: 'camera', model: model_1 },
model_4: { namespace: '@@initialState', model: model_4 },
model_2: { namespace: 'config', model: model_2 },
model_3: { namespace: 'user', model: model_3 },
} as const
